import { shippingMethodStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { css } from "styled-components";

shippingMethodStyles.titleText = {
    variant: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: 16px;
        padding-top: 10px;
        display: none;
    `,
};
shippingMethodStyles.wrapper = {
    css: css`
        display: none;
    `,
};
